import { CommonFieldType } from './utils';
import { UserType } from './user';

export enum SystemConfigKey {
  BUY_FEE = 'BUY_FEE',
  SELL_FEE = 'SELL_FEE',
  TOPUP_FEE = 'TOPUP_FEE',
  WITHDRAW_FEE = 'WITHDRAW_FEE',
  ONLY_INVITED_USER_CAN_REGISTER = 'ONLY_INVITED_USER_CAN_REGISTER',
  REDEEM_ENABLED = 'REDEEM_ENABLED',
  TOPUP_ENABLED = 'TOPUP_ENABLED',
  WITHDRAW_ENABLED = 'WITHDRAW_ENABLED',

  // for setting weekend
  SUNDAY = 'SUNDAY',
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  WEEKLY_START_TIME = 'WEEKLY_START_TIME',
  WEEKLY_END_TIME = 'WEEKLY_END_TIME',

  // for expire waiting transaction
  WAITING_TRANSACTION_EXPIRE_TIME = 'WAITING_TRANSACTION_EXPIRE_TIME',

  // for lv0 balance minimum
  LV0_BALANCE_MINIMUM = 'LV0_BALANCE_MINIMUM',
}

export type SettingType = CommonFieldType & {
  key: SystemConfigKey;
  value: number | boolean;
  description: string;
  approvedByUser?: UserType;
};
